/**
 * A remote-data href earns an anchor only when it is a real, public web URL.
 *
 * Source urls, Ask citations and game receipts arrive from the store as strings. A javascript:
 * value would survive React's escaping and fire on click, so anything without an http(s) scheme
 * renders unlinked. Local and private hosts are refused too: inside the native app the WebView's
 * own origin is https://localhost, and a link to it (Capacitor's internal HTTP proxy path lives
 * there) would load in the app rather than in the system browser.
 */

const LOCAL_HOST = /^(localhost|0\.0\.0\.0|\[?::1\]?)$/i;
const DOT_LOCAL = /\.(local|localhost|internal)$/i;
const PRIVATE_V4 = /^(127\.|10\.|192\.168\.|169\.254\.|172\.(1[6-9]|2\d|3[01])\.)/;

function isPublicHost(hostname: string): boolean {
  const host = hostname.replace(/\.$/, "");
  if (!host) return false;
  if (LOCAL_HOST.test(host) || DOT_LOCAL.test(host) || PRIVATE_V4.test(host)) return false;
  if (host.startsWith("[")) return false; // any other IPv6 literal: no news site lives there
  return true;
}

export function httpHref(url: unknown): string | null {
  if (typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!/^https?:\/\//i.test(trimmed)) return null;
  try {
    return isPublicHost(new URL(trimmed).hostname) ? trimmed : null;
  } catch {
    return null;
  }
}
